import type { AbschnittCElectionCandidate } from "@/lib/abschnittc/AbschnittCElection";

export function abschnittCElectionMaxPoints(candidates: AbschnittCElectionCandidate[]) {
	return candidates.length < 15 ? 5 : 10;
}
